module.exports = __webpack_public_path__ + "img/pic12.03738810.png";